import axios from 'axios'

// let refresh = false

axios.interceptors.response.use((resp) => {
    return resp
  }, async (e) => {
    const originalConfig = e.config;
    // if(originalConfig.url !== '/login' && e.response){
        if (e.response.status == 401 && !originalConfig._retry) {
            originalConfig._retry = true;
            // if (!refresh) {
            //     refresh = true
    
                let data = new FormData
                data.append('refresh', localStorage.getItem('refresh_token'))

                try {
                    let res = await axios.post(`investor/auth/refresh/`, data)
                    localStorage.setItem('access_token', res.data.data.access_token)
                    localStorage.setItem('refresh_token', res.data.data.refresh)
                    
                    const newToken = localStorage.getItem('access_token')
                    originalConfig.headers.Authorization = 'Bearer ' + newToken

                    // console.log('Original Config update header', originalConfig);

                    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
                    return axios.request(originalConfig);
                } catch (error) {
                    console.log('error');
                }

                // var refresh_token = localStorage.getItem('refresh_token');
                // axios.post('investor/auth/refresh/', data)
                // .then(res => {
                //     // console.log('refresh success', res.data.data);
                //     localStorage.setItem('access_token', res.data.data.access_token)
                //     localStorage.setItem('refresh_token', res.data.data.refresh)

                //     const newToken = localStorage.getItem('access_token')
                //     originalConfig.headers.Authorization = 'Bearer ' + newToken
                //     // axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
                //     console.log('Original Config update header', originalConfig);

                //     return axios.request(originalConfig)
                // }).catch((err) => {
                //     console.log('refresh error', err.response);
                // })
            // }
        }
    // }
    return Promise.reject(e.response);
})

axios.interceptors.request.use(async (config) => {
    const token = await localStorage.getItem('access_token');
    // config.headers.Authorization = 'Bearer ' + token;
    config.headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    };

    return config;
},
error => {
    Promise.reject(error)
});
